import { OEETrendCarousel } from "../../components/Carousels/OEECarousel/OEECarousel.view";
import { OEESidebarView } from "../../components/OEEGaugesSidebar/OEEGaugesSidebar.view";

export const PerformanceView = () => {
    return <OEETrendCarousel selectedView={OEESidebarView.PERFORMANCE} />;
};
